(function() {
  'use strict';

  angular
      .module('tfc.News',[])
      .config(config);


  // @ngInject
  function config($stateProvider){

    $stateProvider.state('news',{
      parent : 'pageWithMenu',
      url : '/news',
      templateUrl : 'News/News.tmpl.html',
      data : {
        title:'True Fit News',
        path:'news'
      },
      controller: "NewsCtrl as vm"
    })
  }

})();

